import React, { useContext } from "react";
import { Button, message, Modal } from "antd";
import { YhBox } from "@/erp_subpackage/components/YhBox";
import { useStockCheckModel } from "../stockCheckModel";
import { DataTable } from "./DataTable";
import { MyContext } from "@/store/myContext";
import { DictCodeEnmu } from "@/erp_subpackage/utils/DictCodeEnum";

export const DataBox = () => {
    const { selectedRowKeys, dataSource, searchParam, shopId, exportList, invalidateData } = useStockCheckModel();
    const { state, dispatch, detailsPage } = useContext(MyContext);

    //新增 查看 编辑
    const goPageNav = (mode, rowCode) => {
        let tabName = {
            add: "库存盘点新增",
            edit: "库存盘点编辑",
            look: "库存盘点查看",
        }
        let modeKey = "stockCheck/" + mode;

        //动态传入要删除的nav key
        const handleDispatch = (obj = {}) => {
            dispatch({
                ...obj,
                type: "changeTabs",
                name: tabName[mode],
                activeMenu: modeKey,
                content: detailsPage.StockCheckDetails({
                    modeKey,
                    mode,
                    dispatch,
                    rowCode: rowCode ?? selectedRowKeys[0]
                }),
            })
        }

        if (mode === "edit") {
            const findNav = state.panes.find(item => item.key === modeKey);
            if (findNav) {
                Modal.confirm({
                    title: '温馨提醒！',
                    content: "您还有库存盘点详情未保存，是否跳转",
                    okText: '跳转未保存页',
                    cancelText: '打开新页签',
                    onOk: () => {
                        handleDispatch()
                    },
                    //打开新页签重新生成
                    onCancel: () => {
                        handleDispatch({ deleteKey: modeKey })
                    }
                });
                return;
            }
            handleDispatch()
        }
        else if (mode === "add") {
            handleDispatch()
        }
        else if (mode === "look") {
            handleDispatch({ deleteKey: modeKey })
        }
    }

    //作废
    const cancellation = () => {
        if (selectedRowKeys.length !== 1) {
            message.warning("请选择单条数据进行编辑，点击鼠标右键可一键选中哦！")
            return;
        }
        Modal.confirm({
            title: '盘点点作废',
            type: "error",
            content: <></>,
            okText: '确定',
            cancelText: '取消',
            onOk: () => invalidateData(),
        });
    }

    const action = <>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => {
                goPageNav("add")
            }}
        >新增</Button>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => {
                if (selectedRowKeys.length !== 1) {
                    message.warning("请选择单条数据进行编辑，点击鼠标右键可一键选中哦！")
                    return;
                }
                if (dataSource.find(item => item.stocktakingCode === selectedRowKeys[0]).status === DictCodeEnmu.STOCKTAKING_CHANGE) {
                    message.warning("已作废的单据不可以进行编辑");
                    return;
                }
                goPageNav("edit")
            }}
            disabled={searchParam.shopId === "" || (searchParam.shopId && searchParam.shopId !== shopId)}
        >编辑</Button>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => {
                if (selectedRowKeys.length !== 1) {
                    message.warning("请选择单条数据进行编辑，点击鼠标右键可一键选中哦！")
                    return;
                }
                goPageNav("look")
            }}
        >查看</Button>
        <Button
            className="btn-item"
            shape="round"
            onClick={cancellation}
            disabled={searchParam.shopId === "" || (searchParam.shopId && searchParam.shopId !== shopId)}
        >作废</Button>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => exportList()}
        >导出</Button>
    </>;

    return (
        <YhBox title="盘点列表" action={action}>
            <DataTable goPageNav={goPageNav} />
        </YhBox>
    )
}

